module.exports = __webpack_public_path__ + "mc.svg?2f6d3e1b896b9d4e414c2b830c1d95e5";